<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="560px"
    @click:outside="cerrarDialogo(false)"
  >
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="guardar()">
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <!-- Toolbar Header Principal estilo Inspección -->
        <v-toolbar height="58" color="secondary" dark flat class="px-3 px-md-4">
          <v-icon left>{{ isNuevo ? 'mdi-currency-usd' : 'mdi-pencil-box-outline' }}</v-icon>
          <span class="text-h6 font-weight-medium">
            {{ isNuevo ? 'Nuevo Tipo de Cambio' : 'Editar Tipo de Cambio' }}
          </span>

          <v-chip
            v-if="!isNuevo && Item && Item.id"
            color="white"
            text-color="secondary"
            class="font-weight-bold ml-3 px-3 elevation-1"
            style="font-size: 0.95rem; height: 32px"
          >
            <v-icon left size="18" color="secondary">mdi-pound</v-icon>
            ID: {{ Item.id }}
          </v-chip>

          <v-spacer></v-spacer>

          <v-btn icon dark @click="cerrarDialogo(false)" class="btn-circle-tooltip">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4 pa-md-5">
          <!-- SECCIÓN: DATOS DEL TIPO DE CAMBIO -->
          <div class="section-title d-flex align-center mb-3">
            <v-icon color="secondary" small class="mr-2">mdi-cash-multiple</v-icon>
            <span class="text-subtitle-2 font-weight-bold text--primary">
              Parámetros de Conversión
            </span>
          </div>

          <!-- Mensaje informativo -->
          <v-alert
            dense
            text
            type="info"
            icon="mdi-information-outline"
            class="rounded-lg mb-4 text-caption"
          >
            Establezca el tipo de cambio oficial (Soles por Dólar) y la fecha de vigencia para las conversiones del sistema.
          </v-alert>

          <v-row dense>
            <!-- Campo Valor -->
            <v-col cols="12" sm="6" class="pa-2">
              <v-text-field
                type="number"
                step="0.001"
                label="Valor (S/ por USD) *"
                placeholder="Ej: 3.750"
                hide-details="auto"
                v-model="Item.valor"
                :rules="tipocambio_rule"
                outlined
                dense
                prepend-inner-icon="mdi-currency-usd"
                class="rounded-lg"
                required
              ></v-text-field>
            </v-col>

            <!-- Campo Fecha -->
            <v-col cols="12" sm="6" class="pa-2">
              <v-text-field
                label="Fecha de Vigencia *"
                hide-details="auto"
                type="date"
                v-model="Item.fecha"
                outlined
                dense
                prepend-inner-icon="mdi-calendar"
                class="rounded-lg"
                :rules="[(v) => !!v || 'La fecha es requerida']"
                required
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="d-flex align-center mt-3 text-caption text--secondary">
            <v-icon x-small color="error" class="mr-1">mdi-asterisk</v-icon>
            <span>Campos obligatorios</span>
          </div>
        </v-card-text>

        <!-- Botones de Acción / Footer -->
        <v-card-actions class="pa-4 bg-light border-top d-flex justify-end align-center">
          <v-btn
            outlined
            color="grey darken-1"
            class="text-capitalize px-4 rounded-lg mr-2 font-weight-medium"
            @click="cerrarDialogo(false)"
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>

          <v-btn
            color="primary"
            elevation="2"
            class="text-capitalize px-5 rounded-lg font-weight-bold"
            :loading="loading"
            :disabled="loading || !valid"
            @click="guardar()"
          >
            <v-icon left small>{{ isNuevo ? 'mdi-content-save' : 'mdi-pencil' }}</v-icon>
            {{ isNuevo ? 'Guardar' : 'Actualizar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { notif } from "@/plugins/notyf";

export default {
  props: ["dialog", "Item"],
  data() {
    return {
      valid: false,
      loading: false,
      tipocambio_rule: [
        (v) => !!v || "El valor es requerido",
        (v) => (!isNaN(v) && Number(v) > 0) || "Debe ser un valor numérico mayor a 0",
        (v) => String(v).length <= 7 || "Máximo 7 caracteres"
      ]
    };
  },
  computed: {
    isNuevo() {
      return (
        !this.Item ||
        this.Item.id === 0 ||
        this.Item.id == null ||
        this.Item.id === ""
      );
    }
  },
  methods: {
    ...mapActions("tipocambio", ["agregarTipoCambio", "cargarTipoCambio"]),

    async guardar() {
      if (this.$refs.form && !this.$refs.form.validate()) {
        return;
      }
      this.loading = true;
      try {
        await this.agregarTipoCambio(this.Item);
        this.cerrarDialogo(true);
      } catch (error) {
        this.loading = false;
        console.error("Error al guardar tipo de cambio:", error);
      }
    },

    cerrarDialogo(valor = false) {
      if (valor) {
        this.cargarTipoCambio();
        notif.success(
          this.isNuevo
            ? "Tipo de cambio registrado con éxito"
            : "Tipo de cambio actualizado con éxito"
        );
      }
      this.loading = false;
      this.$emit("closeDialog");
    }
  }
};
</script>

<style scoped>
.section-title {
  border-left: 3px solid #424242;
  padding-left: 8px;
  margin-bottom: 12px;
}

.bg-light {
  background-color: #f8fafc;
}

.border-top {
  border-top: 1px solid #e2e8f0;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}
</style>
